import { authorizedFetch, ErrorResponse } from './api-client';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export interface ImportResult {
  message: string;
  arquivo: string;
  total_processados: number;
  novos: number;
  atualizados: number;
  ignorados: number;
  erros: number;
  detalhes_erros: string[];
}

export async function importAppointments(file: File, clinicId: string): Promise<ImportResult> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('clinic_id', clinicId);

  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/import/appointments`, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const error: ErrorResponse = await response.json();
    throw new Error(error.detail || 'Erro ao importar arquivo.');
  }

  return response.json();
}